import React, {useState, useEffect} from "react";
import update from 'immutability-helper';
import Header from '../../component/Header/Header'
import Footer from '../../component/Footer/Footer.js';
import BlockHeader from "component/BlockHeader/BlockHeader";
import Breadcrumb from "component/Breadcrumb";
import { createBrowserHistory, parsePath } from "history";
import { TalentPoolSlider } from "component/TalentPool";
import _ from "lodash";
import api from "api";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import {InitiativeList} from "component/InitiativeList";
import { Link } from "react-router-dom";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    let history                                 = createBrowserHistory();
    const [talents, setTalents]                 = useState(false);
    const [countTalent, setCountTalent]         = useState(false);
    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [talentLoading, setTalentLoading]                 = useState(false);
    const [initiativeLoading, setInitiativeLoading]         = useState(false);

    const [parameter, setParameter]             = useState({
        search         : queryString.get('s') || ''
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 8
    });

    useEffect(() => {
        
        update(parameter, {
            search : {$set : queryString.get('s')}
        });
        
    }, [queryString.get('s')]);

    const loadInitiative = () => {

        if(initiativeLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/initiative', 'get', parameter)
        ];

        DataToLoad.push(
            api('/initiative', 'get', _.assign({get_total : 1}, parameter))
        );

        setInitiativeLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setInitiativeLoading(false);

                setInitiatives(response[0].initiative);

                setCountInitiative( parseInt(response[1].initiative) );

            })
            .catch((error) => {
                setInitiativeLoading(false);
                
            })
    }

    const loadTalent = () => {

        if(!props.auth.user)
        {
            return;
        }

        if(talentLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/TalentPool', 'post', _.assign({
                include_user_score : 1
                ,include_bio : 1
            }, parameter), 'Bearer ' + props.auth.token)
        ];

        DataToLoad.push(
            api('/TalentPool', 'post', _.assign({get_total : 1}, parameter), 'Bearer ' + props.auth.token)
        );

        setTalentLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setTalentLoading(false);

                setTalents(response[0].talent);

                setCountTalent( parseInt(response[1].talent) );

            })
            .catch(() => {
                setTalentLoading(false);
                
            })
    }
    history.replace(
        { search: queryString.get('search') }
    );
    useEffect(loadInitiative, [props.auth.user, parameter]);
    useEffect(loadTalent, [props.auth.user, parameter]);

    return (
        <>
            <Header/>
                <PageCredential title="Search"/>
                <div className="container">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['Search']
                        ]}
                    />
                    {
                        talentLoading ? <div><span className="skeleton"></span></div> :
                        <>
                            { 
                                <BlockHeader title="Search Talent" desc={"About "+ countTalent +" talents found"}/>
                            }
                        </>
                    }
                    {
                        talents !== false && 
                            <>
                                <TalentPoolSlider talents={talents}/>
                                <div className="text-center mt-4">
                                <Link to={{
                                    pathname : "/talent-pool"
                                    ,search : `?search=${parameter.search}`
                                }} className="btn btn-small btn-orange">See More Talent</Link>
                                </div>
                            </>

                    }
                </div>
                <div className="container">
                    
                    {
                        initiativeLoading ? <div><span className="skeleton"></span></div> :
                        <BlockHeader 
                            title="Search Initiative" 
                            desc={"About "+ countInitiative +" initiatives found"}
                        />
                    }
                    {
                        initiatives !== false && 
                        <>
                            <InitiativeList initiatives={initiatives}/>
                            <div className="text-center mt-4">
                                <Link to={{
                                    pathname : "/initiative"
                                    ,search : `?search=${parameter.search}`
                                }} className="btn btn-small btn-orange">See More Initiative</Link>
                            </div>
                        </>
                    }
                </div>
            <Footer/>
        </>
    )
});